<template>
  <simulador-card :title="$t('tools.surroundingsTitle')">
    <div style="display: flex; width: 100%; flex-wrap: wrap;">
      <simulador-field
        id="quantidade-apartamentos"
        :label="$t('tools.numApartmentsQuestion')"
        type="number"
        :value="quantidadeApartamentos"
        :min="1"
        @input="updateQuantidadeApartamentos"
        @change="calcularTotalMoradores"
      />
      <simulador-field
        id="media-moradores"
        :label="$t('tools.avgResidentsQuestion')"
        type="number"
        :value="mediaMoradores"
        :min="1"
        @input="updateMediaMoradores"
        @change="calcularTotalMoradores"
      />
    </div>
    <div style="clear: both; width: 100%;">
      <simulador-field
        id="total-moradores"
        :label="$t('tools.totalResidentsLabel')"
        :value="totalMoradores"
        :formula="$t('tools.totalResidentsFormula')"
        :is-result="true"
      />
    </div>
  </simulador-card>
</template>

<script>
import SimuladorCard from "./SimuladorCard.vue";
import SimuladorField from "./SimuladorField.vue";

export default {
  name: "EntornoCondominio",
  components: {
    SimuladorCard,
    SimuladorField
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        quantidadeApartamentos: 2322,
        mediaMoradores: 2,
        totalMoradores: 4644
      })
    }
  },
  computed: {
    quantidadeApartamentos: {
      get() {
        return this.value.quantidadeApartamentos;
      },
      set(val) {
        this.$emit("input", { ...this.value, quantidadeApartamentos: val });
      }
    },
    mediaMoradores: {
      get() {
        return this.value.mediaMoradores;
      },
      set(val) {
        this.$emit("input", { ...this.value, mediaMoradores: val });
      }
    },
    totalMoradores: {
      get() {
        return this.value.totalMoradores;
      },
      set(val) {
        this.$emit("input", { ...this.value, totalMoradores: val });
      }
    }
  },
  methods: {
    updateQuantidadeApartamentos(val) {
      this.quantidadeApartamentos = val;
    },
    updateMediaMoradores(val) {
      this.mediaMoradores = val;
    },
    calcularTotalMoradores() {
      const quantidade = parseInt(this.quantidadeApartamentos) || 0;
      const media = parseInt(this.mediaMoradores) || 0;
      const total = quantidade * media;

      this.totalMoradores = total.toFixed(0);
      this.$emit("total-atualizado", total);
    }
  }
};
</script>
